module.exports = __webpack_public_path__ + "404-illustration.be129d13fda8c5b28c697d6cb4925c9c.svg";